import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';

import { Stack } from '@mui/material';

export type SaveMetaDeliveryFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: SaveMetaDeliveryFormProps) => {
  const [
    fnSaveMetaDeliveryForm,
    { loading }
  ] = ds.useSaveMetaDelivery();
  const form = ds.useFormState(props.id);
  const handleSubmit = async (formState: typeof form.formState) => {
    const input = {
      ...formState
    };
    await fnSaveMetaDeliveryForm(input);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(form.formState);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <Stack
        direction='column'
        rowGap='1.5rem'
      >
        <StyledTextField.FC
          {...form.genFieldProps('notesForClient')}
        />

      </Stack>
      <></>
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
